export default __webpack_public_path__ + "static/media/ActiveAlert.0adea1c5.svg";